document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.vw-quality');

  if (!sections.length) return;

  sections.forEach(function (section) {

    const cards = section.querySelectorAll('.vw-quality-card');
    const features = section.querySelectorAll('.vw-quality-feature');

    const observer = new IntersectionObserver(
      function (entries, obs) {

        entries.forEach(function (entry) {

          if (!entry.isIntersecting) return;

          section.classList.add('vw-quality--visible');

          cards.forEach(function (card, index) {
            card.style.transitionDelay = (index * 70) + 'ms';
          });

          features.forEach(function (feature, index) {
            feature.style.transitionDelay = (index * 70) + 'ms';
          });

          obs.unobserve(entry.target);

        });

      },
      {
        threshold: 0.12
      }
    );

    observer.observe(section);

  });

});